<template>
  <el-row>
    <el-row class="BannerContWidth">
      <el-col :span="24">
        <el-col :span="16"
                :xs='24'>
          <div class="DetailsCont">
            <div class="FindCont"
                 v-for="(item, ind) in ArticleListData"
                 :key="ind"
                 @click="ToArticleDetails(item.announcement_id)">
              <p>{{$t('publishType.'+item.publish_type)}}</p>
              <img :src=" item.title_url">
              <div class="FindDetailsCont">
                <div class="FindDetails">
                  <div>
                    <p class="FindDetailsTitle">{{item.title}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :md="{span: 7,offset: 1}"
                :sm="{span: 8,offset: 0}"
                class="hidden-xs-only">
          <QRCode></QRCode>
        </el-col>
      </el-col>
    </el-row>
    <foot></foot>
  </el-row>
</template>

<script>
import QRCode from '@/components/QRCode'
import foot from '@/components/foot'
export default {
  name: 'product',
  components: {
    QRCode,
    foot
    // VueScrollbar
  },
  data () {
    return {
      ArticleListData: []
    }
  },
  created () {
    this.ArticleList()
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    ArticleList () { // 获取新闻列表
      this.$axios.get(this.apiUrl.API.GetContentList, {
        params: {
          pageNum: 0
        }
      })
        .then((res) => {
          this.ArticleListData = res.data.data
        })
    },
    ToArticleDetails (id, Cla) { // 跳转文章详情
      let url
      if (Cla) {
        url = `/ArticleDetails?id=${id}&Cla=${Cla}`
      } else {
        url = `/ArticleDetails?id=${id}`
      }
      this.$router.push({
        path: url
      })
    }
  },
  updated () { }
}
</script>

<style lang="less" scoped>
.BannerContWidth {
  width: 1040px;
  display: flex;
  margin: 0 auto;
}
.DetailsCont {
  width: 100%;
  margin: 1.5rem 0;
}

.FindCont {
  width: 100%;
  margin: 0 0 15px 0;
  cursor: pointer;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  overflow: hidden;
}
.FindCont > p {
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  color: #999;
  background: #fff;
}
.FindCont > img {
  width: 100%;
  display: block;
}
.FindDetailsCont {
  width: 100%;
  background: white;
  display: flex;
  justify-content: space-between;
}
.FindDetails {
  display: flex;
  padding: 1rem 0;
  line-height: 2.333rem;
  padding-left: 0.833rem;
}
.FindDetailsTitle {
  font-size: 16px;
  line-height: 28px;
  color: #333;
  font-weight: 700;
}
.FindDetails > img {
  width: 4.75rem;
  height: 4.75rem;
  margin-right: 1rem;
  border-radius: 1rem;
}
@media (max-width: 1200px) {
  .BannerContWidth {
    width: 88%;
  }
}
@media (max-width: 992px) {
  .BannerContWidth {
    width: 84%;
  }
}
@media (max-width: 768px) {
  .BannerContWidth {
    width: 82%;
  }
}
@media (max-width: 576px) {
  .BannerContWidth {
    width: 90%;
  }
  .FindCont > img {
    // height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue